import { Box, styled } from '@mui/material';

export const ContractInfoRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContractBlock = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px;
  background-color: var(--dk-bg, #fff);
`;

export const ContractBlockHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ContractBlockTitle = styled(Box)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: var(--dk-text, #1d2025);
  word-break: break-word;
`;

export const ContractActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ContractDownloadLink = styled('a')`
  color: var(--dk-accent, #0066cc);
  text-decoration: underline;
`;
